<ion-icon
  *ngIf="!isMyCallcard && canReassign"
  src="assets/icons/engagement/go.svg"
  class="engagement-button"
  (click)="onEngageButtonClicked($event)"
>
</ion-icon>
